import { IonContent, IonPage, IonRouterLink, useIonViewWillEnter } from '@ionic/react'
import { PagingContent, StyleIonHeader } from '../../../components'
import { useContext, useEffect } from 'react'
import { StoresContext } from '../../../provider/StoreProvider'
import moment from 'moment-timezone'
import { DivideLine } from '../../../components/atoms/divide'
import styled from 'styled-components'
import { observer } from 'mobx-react'

export const NoticeMy: React.FC = observer(() => {
  const { commonStore, myStore } = useContext(StoresContext)
  const pagingStore = myStore.noticePagingStore

  useEffect(() => {
    pagingStore.load(undefined, true)
  }, [])

  useIonViewWillEnter(() => {
    commonStore.setShowTab(true)
  })

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'공지사항'} href={'/myPage'} />
      <IonContent>
        <PagingContent emptyText={'조회 가능한 공지사항이 없습니다.'} pagingStore={pagingStore}>
          {pagingStore.list.map((d, i) => (
            <IonRouterLink
              key={i}
              color={'dark'}
              routerLink={
                d.type === 'EVENT'
                  ? `/artfair/${d.extraData.eventId}/event`
                  : d.type === 'ARTICLE'
                  ? `/artfair/${d.extraData.articleId}`
                  : d.type === 'PRODUCT_SALE'
                  ? `/market/${d.extraData.productId}`
                  : `/myPage/notice/${d.id}`
              }
            >
              <ContentContainer>
                <p className="title">{d.title}</p>
                <p className="content">{d.contents.map((c) => c.type === 'header' && c.content)}</p>
                <p className="date">{moment(new Date(d.createdDate)).format('MM월 DD일')}</p>
              </ContentContainer>
              <DivideLine />
            </IonRouterLink>
          ))}
        </PagingContent>
      </IonContent>
    </IonPage>
  )
})

const ContentContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  .title {
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .content {
    font-size: 14px;
    font-weight: 400;
    color: var(--ion-color-primary_light);
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .date {
    font-size: 12px;
    font-weight: 400;
    color: var(--ion-color-gray400);
  }
`
